import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ResourceForm, type ResourceFormInitial } from "@/components/admin/ResourceForm";
import { adminResourceQuery } from "@/lib/query-registry";

export const Route = createFileRoute("/admin/resources/$id")({
  component: EditResource,
});

function EditResource() {
  const { id } = Route.useParams();
  const query = useQuery(adminResourceQuery(id));

  return (
    <div>
      <Link to="/admin/resources" className="text-sm text-muted-foreground hover:text-foreground">
        ← Back to resources
      </Link>
      <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight text-foreground">
        Edit resource
      </h1>
      <div className="mt-8">
        {query.isPending && <p className="text-sm text-muted-foreground">Loading…</p>}
        {query.isError && (
          <div className="flex items-center gap-3">
            <p className="text-sm text-destructive">{query.error.message}</p>
            <button
              type="button"
              onClick={() => query.refetch()}
              className="rounded-full border border-border px-4 py-1.5 text-xs font-medium text-foreground hover:bg-card"
            >
              Retry
            </button>
          </div>
        )}
        {query.isSuccess && query.data?.resource && (
          // Supabase's generated row type is looser than the form's (e.g.
          // JSON/text columns typed as plain string instead of a literal
          // union) because Postgres doesn't encode those constraints in
          // codegen. The row is always well-formed at this boundary in practice.
          <ResourceForm initial={query.data.resource as unknown as ResourceFormInitial} />
        )}
        {query.isSuccess && !query.data?.resource && (
          <p className="text-sm text-muted-foreground">Resource not found.</p>
        )}
      </div>
    </div>
  );
}
